import React, { Component } from "react";
import "./sidebar-btn.css";
import RDP_CONFIG from "../../config";
import { getTheme } from "../../utils/getTheme";
export default class SidebarBtn extends Component {
  render() {
    const isThemeDark = getTheme() === "dark";
    const { icon, label } = this.props;
    return (
      <li className={`rdp-composer-sidebar-btn icon-${icon}`} onClick={() => this.props.click()}>
        <span
          className={`rdp-composer-sidebar-btn-icon ${icon}`}
          style={{
            background: "#5d5d5d",
            ...(isThemeDark && {
              background: "#fff",
            }),
          }}
        ></span>
        <span className="rdp-composer-sidebar-btn-label">{label}</span>
      </li>
    );
  }
}
